import { axios, axios2 } from '@/lib/axios';

type paypalData = {
  payment_url: string;
};

export const paypal = (payload: any): Promise<paypalData> => {
  // const payload = {
  //   subscription_id: id,
  //   price: netAmount,
  // };

  return axios2.post('/subscription-api/make-payment-paypal', payload);
};
